import React from 'react';
import {  CardContent, Typography } from '@mui/material';
import { CardContentStyled, CardItem } from './Card.styles';

interface StatusCardProps {
  filterOption:string;
  title: string;
  count: number;
  handleFilterByCard:(value:string)=>void
  cardfilter:boolean
}

const StatusCard: React.FC<StatusCardProps> = ({filterOption, title, count,handleFilterByCard,cardfilter}) => {
  return (
    <CardItem cardfilter={cardfilter} onClick={()=>{handleFilterByCard(filterOption)}} >
      <CardContent sx={{pb:0,'& .MuiCardContent-root':{pb:0}}}>
        <Typography variant="caption">{title}</Typography>
        <Typography variant="h4" sx={{ fontWeight: 'bold', marginTop: '0.5vw' }}>
          {count}
        </Typography>
      </CardContent>
    </CardItem>
  );
};

export default StatusCard;
